import { pageWh } from "../pageConfig";
// 容器的基本结构
export default {
  elName: "mk-container",
  title: "自由容器",
  previewImage: "", // 预览效果图
  // 容器最外层盒子的样式
  containerStyle: {
    // 容器大盒子的样式
    marginBottom: 0,
    backgroundColor: "#fff",
    backgroundImage: ""
  },
  // 容器画板的默认样式
  commonStyle: {
    width: pageWh.width,
    height: 250,
    position: "relative",
    minHeight: 50, // 容器里面的画板最小高度值
  },
  showTitle: false, // 是否显示头部
  titleBarName: "标题",
  titleBarDesc: '',
  // 容器头部的样式
  titleStyle: {
    height: 50,
    lineHeight: 50
  },
  pointList: ["b"], // 模块拖动的方向有哪些
  allowed: true, // 代表我当前容器是个画板，拖动画板元素可以放到容器上面
  childNode: [], // 容器子节点的集装箱
  editable: 1 // 当前组件是否可以被修改
};
